<template>
  <div v-if="isShow" v-loading="loading" class="radish-right" :style="{ 'z-index': zIndex }">
    <div class="radish-head">
      <div class="radish-title">新建人才</div>
      <div class="radish-btns">
        <div v-show="isSaveShow" class="radish-btn radish-btn-primary" @click="save">保存</div>
        <div class="radish-btn" @click="close">关闭</div>
      </div>
    </div>
    <div v-if="ready" class="radish-body">
      <div class="radish-box">
        <div class="radish-box-content">
          <formItem
            :type="fieldAttach.type"
            :is-inline="true"
            :width="fieldAttach.width"
            :label="fieldAttach.label"
            :options="fieldAttach.options"
            :content="'原始简历'"
            :handle-data-change="handleAttachTypeChange"
          />
          <el-button size="mini" type="primary" round @click="showUpload">文件上传</el-button>
          <el-button v-if="attachType == '原始简历'" size="mini" round @click="showTxtUpload">粘贴上传</el-button>
          <div v-if="attachData[attachType] && attachData[attachType].length > 0">
            <div v-for="(attach, k) in attachData[attachType]" :key="k">
              <b>{{ attach.originalname }}</b>
            </div>
          </div>
          <formItem
            :type="fieldPro.type"
            :is-inline="true"
            :label="fieldPro.label"
            :options="fieldPro.options"
            :content="pid"
            :handle-data-change="handleProChange"
          />
        </div>
      </div>
      <div v-for="(box, k) in fieldsAll" :key="k" class="radish-box">
        <div class="radish-box-title">{{ box.title }}</div>
        <div class="radish-box-content">
          <template v-for="(f, fk) in box.fields">
            <formItem
              :key="fk"
              :type="f.type"
              :is-inline="true"
              :is-required="f.isRequired"
              :width="f.width"
              :label="f.label"
              :placeholder="f.placeholder"
              :options="f.options"
              :content="formData[f.label]"
              :handle-data-change="handleItemChange"
              :handle-blur="handleBlur"
            />
          </template>
        </div>
      </div>
      <div v-for="(box, k) in fieldsExp" :key="k" class="radish-box">
        <div class="radish-box-title">{{ box.title }}</div>
        <div class="radish-box-addbtn" @click="addExp(k)">+</div>
        <div v-for="(c, key) in formExpData[k]" :key="key" class="radish-box-content">
          <div class="radish-box-delbtn" @click="delExp(k, key)">-</div>
          <template v-for="(f, fk) in box.fields">
            <formItem
              :key="fk"
              :type="f.type"
              :is-inline="true"
              :is-required="f.isRequired"
              :width="f.width"
              :label="f.label"
              :box="k"
              :index="key"
              :options="f.options"
              :content="c[f.label]"
              :handle-data-change="handleExpChange"
            />
          </template>
        </div>
      </div>
    </div>
    <UploadDialog ref="UploadDialog" :type="uploadType" :label="attachType" :on-success="uploadSuccess" />
    <TextUploadDialog ref="TextUploadDialog" :on-success="uploadSuccess" />
    <!-- <RecommendCateDialog
      ref="rcdPopup"
      :has-tag-select="hasTagSelect"
      :handle-confirm="doPopupRadish"
    ></RecommendCateDialog> -->
  </div>
</template>
<script>
// import RecommendCateDialog from './dialog/recommend-cate-dialog'
import { UploadDialog, TextUploadDialog } from '../../file'
import { fieldsAll, fieldsExp } from './constant/fields-add'
import { formatCvData } from './constant/common-methods'
import { phoneVali } from './constant/common-methods'
import { preview } from '../../project/src/constant/utils'
import { relatedCates, getDisplayLabels } from './constant/constant'
import { x64hash128 } from 'fingerprintjs2'
let fieldsAllBasicCopy

export default {
  components: { UploadDialog, TextUploadDialog },
  data: function() {
    return {
      zIndex: 1003,
      isShow: false,
      ready: false,
      loading: true,
      isSaveShow: true,
      catData: [],
      fieldsAll: fieldsAll,
      fieldsExp: fieldsExp,
      addFields: [],
      fieldAttach: {
        label: '上传附件',
        type: 'select',
        width: '50%',
        options: ['原始简历', '推荐报告', '背景调查', '薪资证明', '测评报告', '其他资料'],
      },
      fieldPro: {
        label: '加入项目',
        type: 'select',
        options: [],
      },
      formData: {
        地域: [],
        职能模块: [],
        细分职能: [],
        擅长方向: [],
        期望行业: [],
        期望地域: [],
        学历标签: [],
        语言标签: [],
        职业资格: [],
        香港牌照: [],
      },
      formExpData: {
        教育: [{}],
        工作: [{}],
        项目: [{}],
      },
      attachType: '原始简历',
      uploadType: '原始简历',
      attachData: {
        原始简历: [],
        推荐报告: [],
        背景调查: [],
        薪资证明: [],
        测评报告: [],
        其他资料: [],
      },
      dupData: {},
      currentParse: {},
      pid: '',
      requiredFields: ['姓名'],
      hasTagSelect: true,
      addFieldOptions: {
        '承揽-承做': ['承揽', '承做', '存续期管理'],
        期望职能: [],
        '人员背景（股）': ['四大背景', '监管背景', '政府背景', '产业背景', 'VIP', '在大平台做过', '在合资外资做过'],
        平台性质: ['美元/双币种', '人民币', '国家队', '险资', '券商直投', '战投/CVC'],
        投资阶段: ['天使轮及之前', 'PreA', 'A', 'B', 'C', 'Growth/PE', 'Pre-IPO', '一级半定增', 'Buyout'],
        人员背景: ['产业背景', '投行背景', '咨询背景', '四大背景', '政府背景', 'FA背景', '学科背景'],
        特殊能力: ['募资资源', '投后管理', '有退出经验', 'sourcing项目'],
        是否流片: ['是', '否'],
        是否量产: ['是', '否'],
        擅长职能: [
          '人力',
          '财务',
          '法务',
          '销售',
          '市场',
          '设计',
          '产品',
          '运营',
          '研发',
          '质管',
          '注册',
          '采购',
          '生产',
          '供应链',
          '技术',
        ],
        团队业绩: ['0-300万', '300-500万', '500-800万', '800-1000万', '1000-2000万', '2000万+'],
        开票业绩: ['0-30万', '30-50万', '50-80万', ' 80-100万', '100-150万', '150-200万', '200-300万', '300万+'],
        擅长职位: ['50-100万', '30-50万', '10-30万，10万以下', '100-200万', '200万+'],
        客户资源: app.kehuziyuanOpt || [],
        投资标的: ['公募FOF', '私募FOF'],
        公开业绩: ['有', '无'],
        人才来源: [
          '公募公募',
          '公募专户',
          '券商自营',
          '券商资管',
          '保险和保险资管',
          '银行',
          '银行理财子',
          '私募',
          '第三方平台',
          '海外平台',
          '信托',
          '财富公司',
        ],
        医疗背景: ['内资', '外资'],
        转换诉求: ['一级', '卖方', '买方-公募', '买方-保险', '买方-私募', '买方-券商资管', '上市公司董秘'],
        港股背景: ['中资行', '外资行'],
        意向平台: ['国企', '民企', '合资外资', '大平台', '中大型平台', '市场化激励平台'],
        人选背景: [
          '媒体记者出身',
          '4A广告公司',
          '互联网',
          '科技',
          '金融(公募基金）',
          '金融(私募基金）',
          '金融（券商）',
          '外资',
        ],
        REITs任职情况: ['在任', '拟任', '未定'],
        中后台背景: [
          '四大背景',
          '券商背景',
          '公募背景',
          'PE股权',
          '监管背景',
          '外资',
          '海外',
          '咨询',
          'IT系统公司',
          '第三方验证机构',
          '评级机构',
          '海外评级机构',
          '托管',
          '律所',
          '前台业务背景',
          '审计',
          '银行',
          '会计师事务所',
        ],
        HR背景: [
          '金融-公募',
          '金融-券商',
          '金融-私募',
          '金融-PEVC',
          '金融-其他',
          '医疗-医药',
          '医疗-器械',
          '医疗-医疗服务',
          'TMT-互联网',
          'TMT-智能制造',
          'TMT-平台软件',
          '消费-零售',
          '消费-快消',
          '工业-传统工业',
          '工业-工业自动化',
          '咨询-人力咨询',
          '筹备期经验（从0到1）',
          '猎头',
        ],
        薪酬: ['30万以下', '30-50万', '50-80万', '80-100万', '100-150万', '150-200万', '200万以上'],
        医疗科室: [
          '外科',
          '神经外科',
          '脑科学',
          '骨科',
          'ICU',
          '血管外科',
          '心内科',
          '心外科',
          '呼吸科',
          '消化科',
          '内分泌科',
          '急诊科',
          '齿科',
          '眼科',
          '康复科',
          '肾内科',
          '耳鼻喉科',
          '生殖妇产',
          '设备科',
          '影像科',
          '超声科',
          '放射科',
          '信息科',
          '妇产科',
          '肿瘤科',
          '检验科',
          '血液科',
          'LDT三方检验所',
          '药企',
          '高校',
          '皮肤科',
        ],
        投资年限: ['1-3年', '3-7年', '7-10年', '10年以上'],
        业务方向: ['化工', '精细化工', '医药', '石油&天然气', '冶金/矿业', '新能源'],
        公司类型: [
          '国企/央企',
          '民营企业',
          '合资公司',
          '跨国企业',
          '上市公司',
          '非上市公司',
          '集团/控股公司',
          '海外工作',
          '自主创业',
        ],
        上市经验: ['主板上市', '创业板上市', '科创板上市', '新三板上市', '香港上市', '美国上市', '无'],
        业务类型: ['研发业务', '生产业务', '销售和市场业务', '项目业务', '人民币基金', '美元基金'],
        会计准则及证书: [
          '中国会计准则',
          '国际会计准则（IFRS）',
          '美国会计准则（US GAAP）',
          '注册会计师',
          '管理会计师',
          '董秘资格证',
          '证券从业资格',
          '基金从业资格',
          '无',
        ],
        项目及其他技能: [
          '财务系统上线',
          'Oracle系统',
          'SAP系统',
          '新公司设立（0-1）',
          '基金设立',
          '战略',
          '收购并购',
          '定价',
          '财务顾问',
          '无',
        ],
        金融业务方向: ['资管', '投行', '专户', '公募', '自营', '财富管理', '并购'],
        技术方向: ['抗体', '小核酸', '细胞治疗', '基因治疗', '疫苗'],
        治疗领域: [
          '肝病',
          'CNS',
          '眼科',
          '罕见病',
          '抗感染',
          '心血管',
          '内分泌/糖尿病',
          '肾病',
          '妇科/生殖',
          '儿科',
          '消化',
          '呼吸',
          '骨科',
        ],
        技术赛道: ['小分子', '抗体', 'ADC', '小核酸', 'mRNA', '细胞治疗', '基因治疗', '溶瘤病毒'],
        实体瘤: [
          '肺癌',
          '头颈癌',
          '黑色素瘤',
          '泌尿肿瘤',
          '肾癌',
          '妇科肿瘤',
          '乳腺癌',
          '卵巢癌',
          '消化道肿瘤',
          '胃癌',
          '肠癌',
          '肝癌',
          '胰腺癌',
        ],
        医药程序员: ['SASS程序员', '数据库程序员', '统计程序员'],
      },
    }
  },
  created: function() {
    Promise.all([this.loadCate()]).then(() => {
      this.ready = true
      this.loading = false
    })
    this.refreshFielder()
  },
  methods: {
    handleBlur: async function(res) {
      let { label, content } = res
      if (label == '手机') {
        if (content) {
          content = content.replace(/[^0-9]/g, '').replace(/^86(.*?)/, '$1')
          this.formData.手机 = content
          if (phoneVali(content)) {
            const isDup = await this.duplicate(content)
            if (isDup) {
              this.$confirm('系统中已存在相同手机号人选，是否跳转到该人选？', '提示', {
                confirmButtonText: '是，跳转',
                cancelButtonText: '否，返回修改手机号',
                type: 'warning',
              })
                .then(() => {
                  window.open(`${window.frontend}/#/radish-detail-blank/${this.dupData.id}`)
                  this.close()
                })
                .catch(() => {
                  this.formData['手机'] = ''
                  this.dupData = {}
                  this.isSaveShow = true
                })
              return false
            }
          } else {
            this.$message.info('手机格式错误')
            this.dupData = {}
            return false
          }
        } else {
          this.dupData = {}
          this.isSaveShow = true
        }
      } else if (label == '本科院校') {
        this.formData[label] = content
        if (content) {
          if (this.formExpData['教育'].find(e => e.学历 === '本科')) {
            this.formExpData['教育'] = this.formExpData['教育'].map(e => {
              if (e.学历 === '本科') e.学校 = content
              return e
            })
          } else {
            this.formExpData['教育'].unshift({ 学历: '本科', 学校: content })
          }
        } else {
          this.formExpData['教育'] = this.formExpData['教育'].filter(e => e.学历 !== '本科')
        }
      } else if (label == '硕士院校') {
        this.formData[label] = content
        if (content) {
          if (this.formExpData['教育'].find(e => e.学历 === '硕士')) {
            this.formExpData['教育'] = this.formExpData['教育'].map(e => {
              if (e.学历 === '硕士') e.学校 = content
              return e
            })
          } else {
            this.formExpData['教育'].unshift({ 学历: '硕士', 学校: content })
          }
        } else {
          this.formExpData['教育'] = this.formExpData['教育'].filter(e => e.学历 !== '硕士')
        }
      }
      return true
    },
    handleItemChange: async function(res) {
      const { label, content } = res
      if (label == '职能模块') {
        this.formData[label] = content
        await this.refreshFielder()
        this.ready = false
        const currentCat = this.catData.filter(cat => content.includes(cat['名称']))
        if (currentCat.length > 0) {
          let znArr = []
          let scArr = []
          currentCat.forEach(cat => {
            if (cat['二级职能'] && cat['二级职能'].length > 0) {
              znArr = znArr.concat(cat['二级职能'])
            }
            if (cat['擅长方向'] && cat['擅长方向'].length > 0) {
              scArr = scArr.concat(cat['擅长方向'])
            }
          })
          this.fieldsAll['基本信息'].fields['细分职能'].options = this.unique(znArr)
          this.fieldsAll['基本信息'].fields['擅长方向'].options = this.unique(scArr)
          this.fieldsAll['基本信息'].fields['专业职级'].options =
            content && content.includes('HH-猎头')
              ? ['R', 'AC', 'C', 'SC', 'PC', 'TL\M', 'SM', 'AD', 'D', 'AP', 'P', 'SP', 'Office Head', 'GM', 'CEO']
              : ['ManagingPartner', 'Partner', 'MD', 'ED', 'D', 'AD', 'SVP', 'VP', 'SA', 'Asso', 'AN']
        }
        this.ready = true
      } else if (label == '从业起始年') {
        this.formData[label] = parseInt(content)
      } else {
        this.formData[label] = content
      }
    },
    handleExpChange: function(res) {
      const { label, content, box, index } = res
      this.formExpData[box][index][label] = content
    },
    handleProChange: function(res) {
      const { label, content } = res
      this.pid = content
      // if (!this.formData['手机']) {
      //   this.$message.info('请填写手机');
      //   return;
      // }
    },
    handleAttachTypeChange: function(res) {
      const { label, content } = res
      this.attachType = content
      if (content == '原始简历') {
        this.uploadType = '原始简历'
      } else if (content == '推荐报告') {
        this.uploadType = '推荐报告'
      } else if (content == '会面记录') {
        this.uploadType = '会面记录'
      } else {
        this.uploadType = '附件'
      }
    },
    duplicate: async function(phone) {
      const dup = await app.service('radish').duplicate({ phone: phone })
      if (dup.msg == 'duplicate') {
        this.dupData = dup.data
        this.isSaveShow = false
        return true
      } else {
        this.dupData = {}
        this.isSaveShow = true
        return false
      }
    },
    save: async function() {
      if (this.loading) return this.$message.info('保存中请稍候...')
      const dt = JSON.parse(JSON.stringify(this.formData))
      const edt = JSON.parse(JSON.stringify(this.formExpData))
      const vali = await this.fieldValidate(dt, edt)
      if (!vali) {
        return false
      }
      if (dt['手机']) {
        const ok = await this.handleBlur({
          label: '手机',
          content: dt['手机'],
        })
        if (!ok) {
          return false
        }
      }
      dt['姓名'] = dt['姓名'] ? dt['姓名'].replace(' ', '') : ''
      this.loading = true
      const result = await this.saveForm(dt)
      console.log('basic', result)
      if (result.status == 'success') {
        const rid = result.data.id
        const aRes = await this.saveAttach(rid)
        const eRes = await this.saveExp(edt, rid)
        if (this.formData['客户资源'] && this.formData['客户资源'].length > 0) {
          app.user.kehuziyuanOpt = Array.from(
            new Set((app.user.kehuziyuanOpt || []).concat(this.formData['客户资源'] || [])),
          )
          await app.service('users').patch(app.user._id, {
            kehuziyuanOpt: app.user.kehuziyuanOpt,
          })
        }
        console.log('a', aRes)
        console.log('e', eRes)
        if (this.pid) {
          const pRes = await this.intoPro(rid)
          if (pRes.status == 'success') {
            this.$notify({
              title: `人选${dt['姓名']}成功添加并加入项目`,
              dangerouslyUseHTMLString: true,
              message: '<span class="radish-link">点击查看</span>',
              onClick: () => {
                window.open(`${window.frontend}/#/radish-detail-blank/${rid}`, '_blank')
              },
            })
          } else {
            this.$message.error(`intopro error:${pRes.msg}`)
          }
        } else {
          this.$notify({
            title: `人选${dt['姓名']}添加成功`,
            dangerouslyUseHTMLString: true,
            message: '<span class="radish-link">点击查看</span>',
            onClick: () => {
              window.open(`${window.frontend}/#/radish-detail-blank/${rid}`, '_blank')
            },
          })
        }
        this.close()
        // router.push('/radish-detail/'+rid);
      } else {
        this.$message.error(`save error:${result.msg}`)
      }
      this.loading = false
    },
    fieldValidate: function(dt, edt) {
      const empty = []
      this.requiredFields.forEach(f => {
        if (f instanceof Object) {
          for (const key in f) {
            const farr = f[key]
            farr.forEach(f2 => {
              if (!edt[key][0][f2]) {
                empty.push(f2)
              }
            })
          }
        } else if (!dt[f]) {
          empty.push(f)
        }
      })
      if (empty.length > 0) {
        this.$alert(`请填写${empty.join('、')}`, { showClose: false })
        return false
      }
      // if (this.pid && !dt['手机']) {
      //   this.$alert('加入项目请先填写手机', {showClose: false});
      //   return false;
      // }
      return true
    },
    saveForm: async function(dt) {
      dt.from = 'add'
      const result = await app.service('radish').insert(dt)
      await app.service('misc').insertBussinessAssistTask({
        type: '新建人选',
        data: { radishId: result.data.id, 姓名: dt.姓名 },
      })
      return result
    },
    saveAttach: async function(rid) {
      const dt = []
      const adt = JSON.parse(JSON.stringify(this.attachData))
      for (const key in adt) {
        const tmp = adt[key].forEach(item => {
          item.rid = rid
          item.type = key
          dt.push(item)
        })
      }
      if (dt.length > 0) {
        const aRes = await app.service('radish').addAttachment(dt)
        return aRes
      } else {
        return { status: 'fail', msg: '未添加附件' }
      }
    },
    saveExp: async function(edt, rid) {
      const dt = []
      for (const key in edt) {
        const tmp = edt[key].forEach(item => {
          if (Object.keys(item).length > 0) {
            item.rid = rid
            item.type = key
            dt.push(item)
          }
        })
      }
      if (dt.length > 0) {
        const eRes = await app.service('radish').addExperience(dt)
        const comDt = dt.filter(d => d.type == '工作')
        if (comDt.length > 0) {
          await app.service('radish').modifyById({ _id: rid, data: { 任职经历: comDt } })
        }
        return eRes
      } else {
        return { status: 'fail', msg: '未添加经历' }
      }
    },
    intoPro: async function(rid) {
      const pRes = await app.service('radish').intoProject({ pid: this.pid, rid: rid })
      return pRes
    },
    addExp: function(k) {
      this.formExpData[k].unshift({})
    },
    delExp: function(type, index) {
      this.$confirm('确定删除该经历吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          this.formExpData[type].splice(index, 1)
        })
        .catch(() => {})
    },
    showUpload: function() {
      this.$refs.UploadDialog && this.$refs.UploadDialog.visible(true)
    },
    showTxtUpload: function() {
      this.$refs.TextUploadDialog && this.$refs.TextUploadDialog.visible()
    },
    // showRadish: function(params) {
    //   const { id, name } = params
    //   app.root.$refs.radishLeft.show(id)
    // },
    uploadSuccess: async function(response, file, fileList) {
      response.forEach(res => {
        const dt = {
          fileId: res._id,
          uploader: res.uploader,
          originalname: res.originalname,
          src: res.src,
          md5: res.md5,
          简历打分: res.简历打分,
        }
        this.attachData[this.attachType].unshift(dt)
      })
      this.$refs.UploadDialog && this.$refs.UploadDialog.visible()
      if (this.attachType == '原始简历') {
        const radishCvUpload = app.root.$refs.radishCvUpload
        radishCvUpload.open()
        radishCvUpload.uploadFiles = [this.attachData[this.attachType][0]]
        await radishCvUpload.handleImport()
        this.$nextTick(() => {
          this.close()
        })
      }
    },
    doPopupRadish: async function(rid, file) {
      this.close()
      await app.root.$refs.radishDetailTab.addTab({ id: rid })
      app.root.$refs.radishLeft.close()
      preview(file)
    },
    mergeOne: async function(main) {
      if (this.dupData.id && this.currentParse.fileId) {
        this.loading = true
        const rid = this.dupData.id
        const n = JSON.parse(JSON.stringify(this.formData))
        const edt = JSON.parse(JSON.stringify(this.formExpData))
        const attachs = []
        const adt = JSON.parse(JSON.stringify(this.attachData))
        for (const key in adt) {
          const tmp = adt[key].forEach(item => {
            item.rid = rid
            item.type = key
            attachs.push(item)
          })
        }
        const nExp = []
        for (const key in edt) {
          const tmp = edt[key].forEach(item => {
            if (Object.keys(item).length > 0) {
              item.rid = rid
              item.type = key
              nExp.push(item)
            }
          })
        }
        const data = [
          {
            o: { _id: this.dupData.id },
            n: n,
            nExp: nExp,
            nAttach: attachs,
          },
        ]
        const res = await app.service('radish').merge({
          data: data,
          main: main,
          from: 'cv',
        })
        if (res.status == 'success') {
          console.log(this.pid)
          if (this.pid) {
            const pRes = await this.intoPro(rid)
            if (pRes.status == 'success') {
              this.$message.success({
                duration: 500,
                message: '合并成功并加入项目成功',
              })
            } else {
              console.log(`intopro error:${pRes.msg}`)
            }
          } else {
            this.$message.success({ duration: 500, message: '合并成功' })
          }
          this.close()
          router.push(`/radish-detail-blank/${this.dupData.id}`)
        } else {
          this.$message.error(res.msg)
        }
        this.loading = false
      }
    },
    loadCate: async function() {
      if (!app.categories) {
        await app.getCats()
      }
      const catData = app.categories
      if (catData && catData.length > 0) {
        this.catData = catData
        this.fieldsAll['基本信息'].fields['职能模块'].options = catData.map(item => item['名称'])
      }
      this.fieldsAll['基本信息'].fields['行业'].options = app.industries
      fieldsAllBasicCopy = JSON.parse(JSON.stringify(fieldsAll.基本信息.fields))
    },
    loadPro: async function() {
      if (!app.projects) {
        await app.getProjects()
      }
      const proData = app.projects
      if (proData && proData.length > 0) {
        const opts = {}
        proData.forEach(item => {
          const v = `${item['项目名称']}(${item['客户公司']})`
          opts[item._id] = v
        })
        this.fieldPro.options = opts
      }
    },
    unique: function(arr) {
      return Array.from(new Set(arr))
    },
    open: async function(opts, pid) {
      this.reset(opts)
      this.loadPro()
      if (pid) this.pid = pid
      this.isShow = true
    },
    close: function() {
      this.isShow = false
    },
    reset: function(opts) {
      this.formData = {
        地域: [],
        职能模块: [],
        细分职能: [],
        擅长方向: [],
        期望行业: [],
        期望地域: [],
        学历标签: [],
        语言标签: [],
        职业资格: [],
        香港牌照: [],
      }
      this.formExpData = {
        教育: [{}],
        工作: [{}],
        项目: [{}],
      }
      this.attachType = '原始简历'
      this.uploadType = '原始简历'
      this.attachData = {
        原始简历: [],
        推荐报告: [],
        背景调查: [],
        薪资证明: [],
        测评报告: [],
        其他资料: [],
      }
      this.dupData = {}
      this.currentParse = {}
      this.isSaveShow = true
      this.pid = ''
      if (opts) {
        if (opts.defaultPid) {
          this.pid = opts.defaultPid
        }
        if (opts['姓名']) {
          this.formData['姓名'] = opts['姓名']
        }
        if (opts['公司']) {
          this.formData['公司'] = opts['公司']
        }
      }
    },
    closePreview: function() {
      this.previewVisible = false
    },
    resetFields() {
      const fieldsAllBasicCopyCopy = JSON.parse(JSON.stringify(fieldsAllBasicCopy))
      this.$nextTick(() => {
        this.$set(this.fieldsAll.基本信息, 'fields', fieldsAllBasicCopyCopy)
      })
    },
    refreshFielder() {
      const isReatedCate = this.formData.职能模块 && this.formData.职能模块.filter(v => relatedCates.includes(v))
      const addFields = getDisplayLabels(this.formData && this.formData.职能模块)
      if (!isReatedCate || !addFields || addFields.length === 0) {
        this.resetFields()
      } else {
        if (addFields.length > 0) {
          this.$nextTick(() => {
            const fieldsAllBasicCopyCopy = JSON.parse(JSON.stringify(fieldsAllBasicCopy))
            this.$set(this.fieldsAll.基本信息, 'fields', fieldsAllBasicCopyCopy)
            this.$nextTick(() => {
              for (const addField of addFields) {
                this.$set(this.fieldsAll.基本信息.fields, addField, {
                  label: addField,
                  width: '32%',
                  type: ['是否量产', '是否流片'].includes(addField) ? 'select' : 'multSelect',
                  options: this.addFieldOptions[addField] || [],
                })
              }
            })
          })
        }
      }
    },
  },
}
</script>
